import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { ChartContainer } from "../../view/ChartContainer";
import { debug } from "../../utils";
import { CustomTooltip } from "../../dashboard/components/CustomTooltip";
import { transformDeviceDetailsStackedBarData } from "../../dashboard/utils/chartDataTransformers";
import { VALIDATION_COLORS } from "../../dashboard/constants/chartColors";
import * as statisticService from "../../dashboard/statisticService";
import { connect } from "react-redux";
import { AuditScope } from "../../dashboard/chartDynamicLabels";
import { InteractiveLegend } from "../../dashboard/components/InteractiveLegend";
import DeviceDetailsChartSkeleton from "./DeviceDetailsChartSkeleton";

function ConfigChangesChart({ id }) {

    const [scope, setScope] = useState(AuditScope.BY_MONTH);
    const [rechartsData, setRechartsData] = useState([]);
    const [hiddenSeries, setHiddenSeries] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async (deviceId) => {
        setIsLoading(true);
        try {
            const sData = await statisticService.getChangesByDateByDeviceId(scope, deviceId);
            if (sData && sData.labels && sData.datasets) {
                // Transform data for Recharts using the dedicated device details transformer
                const transformed = transformDeviceDetailsStackedBarData(sData);
                setRechartsData(transformed);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        id && fetchData(id);
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [scope, id])
    
    
    // useEffect(() => {

    //     // opt.scales.xAxes[0].time.displayFormats.day = scope === 'Day' ? 'DD/MM/YYYY' : 'MMM'
    //     id && statisticService.getChangesByDateByDeviceId(scope, id).then(data => setChartData(data));
    // }, [scope, id])

    // Handle legend click to toggle series visibility
    const handleToggleSeries = (dataKey) => {
        setHiddenSeries(prev => ({
            ...prev,
            [dataKey]: !prev[dataKey]
        }));
    };

    const monthButton = { label: AuditScope.BY_MONTH, onClick: () => setScope(AuditScope.BY_DAY), className: "btn oct_btn-form-v2 oct_dashboardrange-btn-v2" }
    const dayButton = { label: AuditScope.BY_DAY, onClick: () => setScope(AuditScope.BY_MONTH), className: "btn oct_btn-form-v2 oct_dashboardrange-btn-v2" }
    const buttonToShow = scope === AuditScope.BY_MONTH ? monthButton : dayButton;

    if (isLoading) {
        return <DeviceDetailsChartSkeleton title="Configuration Changes" buttons={[buttonToShow]} />;
    }

    return (
        <ChartContainer title="Configuration Changes" buttons={[buttonToShow]} className="">
            <div className="oct_interactive-legend-wrapper-v2">
                <InteractiveLegend
                    payload={[
                        { value: 'Suspicious', color: VALIDATION_COLORS.suspicious, dataKey: 'suspicious' },
                        { value: 'Violation', color: VALIDATION_COLORS.violation, dataKey: 'violation' },
                        { value: 'Normal', color: VALIDATION_COLORS.normal, dataKey: 'normal' }
                    ]}
                    hiddenSeries={hiddenSeries}
                    onToggleSeries={handleToggleSeries}
                />
            </div>
            <div className="oct_recharts-wrapper-v2 oct_chart-no-interaction">
                <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 10, height: 10 }}>
                    <BarChart data={rechartsData}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                        <XAxis
                            dataKey="label"
                            stroke="#94a3b8"
                            tick={{ fontSize: 12 }}
                        />
                        <YAxis
                            stroke="#94a3b8"
                            tick={{ fontSize: 12 }}
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Bar
                            dataKey="suspicious"
                            stackId="a"
                            fill={VALIDATION_COLORS.suspicious}
                            name="Suspicious"
                            hide={hiddenSeries['suspicious']}
                        />
                        <Bar
                            dataKey="violation"
                            stackId="a"
                            fill={VALIDATION_COLORS.violation}
                            name="Violation"
                            hide={hiddenSeries['violation']}
                        />
                        <Bar
                            dataKey="normal"
                            stackId="a"
                            fill={VALIDATION_COLORS.normal}
                            radius={[8, 8, 0, 0]}
                            name="Normal"
                            hide={hiddenSeries['normal']}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </ChartContainer>
    )

}

function mapStateToProps(state) {
    debug("ConfigChangesChart mapStateToProps", state);
    const deviceDetailsPage = state.deviceDetailsPage;
    const deviceId = deviceDetailsPage.device ? deviceDetailsPage.device.id : null;
    return {
        id: deviceId
    }
}

export default connect(mapStateToProps)(ConfigChangesChart);
